module.exports = __webpack_public_path__ + "static/gom-a5f68c1b847da4dbde4f6bf15a94d53d.jpeg";